import { Components, Theme } from '@mui/material/styles';

export const MuiDialogTitle: Components<Theme>['MuiDialogTitle'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(12, 16, 8, 16),
    }),
  },
};
